export default __webpack_public_path__ + "static/media/image4.72e94688.jpg";